import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useDateOfBirthVerificationStatusStore = defineStore('dateOfBirthVerificationStatus', () => {
    const verificationRequired = ref(true);
    const isVerificationRequired = computed(() => verificationRequired.value);

    const verified = ref(false);
    const isVerified = computed(() => verified.value);

    function $reset() {
        verificationRequired.value = true;
        verified.value = false;
    }

    return { verificationRequired, isVerificationRequired, verified, isVerified, $reset }
}, { persist: true })
